import React, { Component, PropTypes } from 'react';

let didEvieSaysScriptLoad = false;

class EvieSays extends Component {
  static propTypes = {
    siteName: PropTypes.string.isRequired,
    labelType: PropTypes.string
  }

  static defaultProps = {
    labelType: 'default'
  }

  componentDidMount() {
    if (!didEvieSaysScriptLoad) {
      const parent = document.getElementById('EvieSays');
      const child = document.createElement('script');

      child.type = 'text/javascript';
      child.src = `https://widget.eviesays.com/widget/embed.js?site=${this.props.siteName}&label=${this.props.labelType}`;
      child.async = true;

      parent.appendChild(child);
      didEvieSaysScriptLoad = true;
    }
  }

  render() {
    return (
      <div id="EvieSays" className="frankly-ads-EvieSays"></div>
    );
  }
}

export default EvieSays;



// WEBPACK FOOTER //
// ./app/components/ads/EvieSays.js